/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleTransferStatus = {
    type: 'Enum',
};